import React from "react";
import { default as ReactModal } from "react-modal";
import { Card } from "@masterteam/mt-design-react";
import "./style.scss";

ReactModal.setAppElement(document.getElementById("root"));

function Modal({ children, isOpen, ...rest }) {
  return (
    <div>
      <ReactModal isOpen={isOpen} {...rest}>
        <Card onClick={e => e.stopPropagation()} className="modal__content">
          {children}
        </Card>
      </ReactModal>
    </div>
  );
}

export default Modal;
